const state = {
  bounds: {
    ne: {lat: 47.79101617826261, lng: -122.20848083496095},
    sw: {lat: 47.42111891027388, lng: -122.45567321777345}
  }
}

const mutations = {
  SET (state, bounds) {
    state.bounds = bounds
  }
}

const actions = {
  set: function ({commit}, bounds) {
    commit('SET', bounds)
  }
}

const getters = {
  get: function (state) {
    return state.bounds
  }
}

export const FilterMapBounds = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/filters/FilterMapBounds.js